import { IoIosArrowBack } from "react-icons/io";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import AnimatedWrapper from "../components/AnimatedWrapper";
import ProgressBar from "../components/ProgressBar";
import ImprovementGraph from "../components/Animations/animation21";
import amplitude from "../utils/amplitude";
import { useEffect } from "react";

export default function Page21() {
  const navigate = useNavigate();

  useEffect(() => {
        if(process.env.NODE_ENV === "production"){
              amplitude.track('Quiz Step Open', {
            step_number: 21,
          });
            }
  }, [])

  const nextStep = () => {
    if(process.env.NODE_ENV === "production"){
      amplitude.track('Quiz Step Complete', {
        step_number: 21, 
        answers:""
      });

    }
    navigate("/quiz22");
  };

  const stepBack = () => {
    navigate("/quiz20");
  };

  return (
    <AnimatedWrapper>
      {/* Верхняя панель с кнопкой назад и прогрессом */}
      <div className="flex items-center space-x-2 p-2">
        <button className="text-gray-600" onClick={() => stepBack()}>
          <IoIosArrowBack size={24} />
        </button>
        <ProgressBar />
      </div>
      <ImprovementGraph />
      <motion.div
        initial={{ opacity: 0, x: 10, y: 10 }}
        animate={{ opacity: 1, x: 0, y: 0 }}
        transition={{ delay: 2.2 }}
        className="relative left-[90%] bottom-4 z-50"
      >
        <svg
          width="25"
          height="62"
          viewBox="0 0 25 62"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.27527 59.3968C1.72569 59.4514 1.32442 59.9412 1.37902 60.4908C1.43362 61.0404 1.9234 61.4416 2.47298 61.387L2.27527 59.3968ZM22.6747 31.2816L21.6946 31.48L22.6747 31.2816ZM1.61926 3.55021C1.09495 3.72376 0.81061 4.28949 0.984164 4.8138L3.81238 13.3579C3.98593 13.8822 4.55166 14.1665 5.07597 13.993C5.60027 13.8194 5.88462 13.2537 5.71106 12.7294L3.19709 5.13465L10.7918 2.62068C11.3161 2.44712 11.6005 1.88139 11.4269 1.35709C11.2534 0.832782 10.6876 0.54844 10.1633 0.721993L1.61926 3.55021ZM2.37412 60.3919L2.47298 61.387C15.853 60.0578 27.0128 47.6692 23.6548 31.0831L22.6747 31.2816L21.6946 31.48C24.8081 46.8585 14.5253 58.1799 2.27527 59.3968L2.37412 60.3919ZM22.6747 31.2816L23.6548 31.0831C20.2362 14.1975 6.18661 5.51801 2.38259 3.60606L1.9335 4.49955L1.48443 5.39304C5.10006 7.21031 18.46 15.5038 21.6946 31.48L22.6747 31.2816Z"
            fill="#FC5EB2"
          />
        </svg>
      </motion.div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2.2, duration: 0.5 }}
        className="relative -top-10"
      >
        <div className="flex items-start gap-4 mx-auto py-5 px-5 max-w-[350px] bg-white rounded-xl border border-gray-200 shadow-xl text-sm">
          <img
            src="/img21-1.svg"
            alt="Skincare"
            className="w-[50px] h-[50px] object-center flex-shrink-0"
          />

          <div className="flex flex-col">
            <span className="text-left font-medium">
              Research by Harvard Medical School
            </span>
            <p className="text-left text-xs text-gray-500 mt-1">
              Shows significant benefits from consistent routines:
            </p>
          </div>
        </div>
      </motion.div>

      <div className="w-full px-4 py-3 mb-2 text-center flex flex-col items-center space-y-4">
        <h2 className="text-xl font-semibold leading-snug">
          Your treatment program is a 87% fit to you thanks to hydration,
          sensitivity & goal
        </h2>
        <button
          className="bg-pinkCustom text-white mt-auto w-full py-3 rounded-full font-semibold hover:bg-pinkCustom transition"
          onClick={() => nextStep()}
        >
          Next
        </button>
      </div>
    </AnimatedWrapper>
  );
}
